const productTypeGroups = {
  makeup: 'Makeup',
  homeFragrance: 'HomeFragrance',
  perfume: 'Perfume',
  bathBody: 'BathBody', // TODO replace usage to skincare and remove
  skincare: 'BathBody',
  wellness: 'Wellness', // TODO remove if it doesn't change from BathBody to Wellness in SB-414
  personalCare: 'PersonalCare',
  perfumeCase: 'PerfumeCase',
  candleSet: 'CandleSet',
  fragranceStorageBox: 'FragranceStorageBox',
  perfumeOfTheMonth: 'PerfumeOfTheMonth',
}


export default productTypeGroups
